import React, { useContext, useEffect } from "react";
import { ResultStatsContext } from "../../context/ResultStatsContext";

export const NoResults: React.FC = () => {
  const { setDisplayedResults, setNumberOfResults } = useContext(ResultStatsContext);

  useEffect(() => {
    setDisplayedResults(null);
    setNumberOfResults(null);
  }, []);

  return (
    <div className="text-center py-16">
      <strong className="block mb-4">No results found.</strong>
    </div>
  );
};
